import { Component, Input, effect, inject, signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { UiKitModule } from "@app/ui-kit.module";
import { ConfigurationWizardHeaderComponent } from "@components/configuration-wizard-header/configuration-wizard-header.component";
import { Gas } from "@domain/gas/gas";
import { Product } from "@domain/product/product";
import { ProductPriceData } from "@domain/product/product-price-data";
import { ProductService } from "@domain/product/product.service";
import { UserService } from "@domain/user/user.service";
import { map } from "rxjs";

@Component({
  selector: "app-configuration-wizard-header-accordion",
  templateUrl: "./configuration-wizard-header-accordion.component.html",
  styleUrls: ["./configuration-wizard-header-accordion.component.scss"],
  imports: [UiKitModule, ConfigurationWizardHeaderComponent],
  standalone: true,
})
export class ConfigurationWizardHeaderAccordionComponent {
  private productService = inject(ProductService);
  private userService = inject(UserService);

  private readonly showZrefPrices = toSignal(this.userService.user$.pipe(map((user) => user.showZrefPrices)), {
    initialValue: false,
  });

  @Input({ required: true }) showCosts!: boolean;

  @Input({ required: true }) set selectedData(selectedData: (Gas | Product)[]) {
    this.dataSignal.set(selectedData);
  }

  @Input({ required: true }) prefix!: string;
  @Input({ required: true }) title!: string;

  private readonly dataSignal = signal<(Gas | Product)[]>([]);
  protected data: (Gas | Product)[] = [];
  protected totalCosts: number = 0;
  protected priceData?: ProductPriceData;

  constructor() {
    effect(() => {
      this.data = this.dataSignal();
      this.totalCosts = this.calculateTotalCosts();
    });
  }

  private calculateTotalCosts() {
    if (!this.data.length) {
      return 0;
    }
    return this.data
      .map((product) => {
        if (product instanceof Product) {
          const showZref = this.showZrefPrices();
          const regularPrice = this.productService.getPriceData(product);
          const zrefPrice = this.productService.getZrefPriceData(product);
          this.priceData = showZref ? zrefPrice : regularPrice;
          return this.priceData ? this.priceData.price : 0;
        }
        return 0;
      })
      .reduce((a, b) => a + b);
  }
}
